import { App } from "vue";
import type { I18n, I18nOptions } from "vue-i18n";
//import messages from "@intlify/vite-plugin-vue-i18n/messages";
import { createI18n } from "vue-i18n";
import en from "../locales/en.json";
import de from "../locales/de.json";
const localeData: I18nOptions = {
  legacy: false,
  fallbackLocale: ["de"],
  availableLocales: ["de", "en"],
  sync: true, //If you don’t want to inherit locale from global scope, you need to set sync of i18n component option to false.
  silentTranslationWarn: true, // true - warning off
  missingWarn: false,
  silentFallbackWarn: true,
  locale: "de",
  messages: {
    en,
    de,
  },

  //fallbackLocale: "de",
  //localeDir: "locales",
  // enableInSFC: true,
};

let i18n: I18n;

// setup i18n instance with glob
export function setupI18n(app: App) {
  i18n = createI18n(localeData) as I18n;
  // loadLocaleMessages(i18n, "en");
  // loadLocaleMessages(i18n, "de");

  // setupLocale();
  app.use(i18n);
}

export function getI18n(): I18n {
  return i18n;
}

export async function loadLocaleMessages(i18n: I18n, locale: string) {
  // load locale messages
  const messages = await import(/* @vite-ignore */ `../locales/en.json`);

  i18n.global.setLocaleMessage(locale, messages);
}
